/* eslint-disable no-console */
import { takeLatest, call, put, select } from 'redux-saga/effects';

// Connected React Router

// Services
import { schedulesMatrixApi } from 'services/apiDigitalTicket/schedulesMatrix';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';
import PATH from 'constants/basePath';

// Actions
import * as SchedulesMatrixActions from './actions';

// Types
import { SchedulesMatrixTypes } from './types';

function* list({
  payload,
}: ReturnType<typeof SchedulesMatrixActions.listSchedulesMatrixRequest>): any {
  try {
    yield put(
      DialogsActions.setSecondOpenLoading({ title: 'Carregando matrizes' }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.get, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        SchedulesMatrixActions.listSchedulesMatrixSuccess({
          schedulesMatrixList: response.data,
          totalCount: parseInt(response.headers.totalcount, 10),
        }),
      );

      yield put(DialogsActions.setSecondClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schedulesMatrix - listSchedulesMatrix - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.listSchedulesMatrixFailure());
    yield put(DialogsActions.setClose());
  }
}

function* get({
  payload,
}: ReturnType<typeof SchedulesMatrixActions.getSchedulesMatrixRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando dados' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.get, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        SchedulesMatrixActions.getSchedulesMatrixSuccess({
          schedulesMatrixData: response.data,
        }),
      );
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schedulesMatrix - getSchedulesMatrix - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.getSchedulesMatrixFailure());
    yield put(DialogsActions.setClose());
  }
}

function* create({
  payload,
}: ReturnType<
  typeof SchedulesMatrixActions.createSchedulesMatrixRequest
>): any {
  try {
    // yield put(DialogsActions.setOpenLoading({ title: 'Criando matriz' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.create, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        SchedulesMatrixActions.createSchedulesMatrixSuccess({
          schedulesMatrixData: response.data,
        }),
      );
      /* yield put(DialogsActions.setClose());

       yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Matriz criada com sucesso',
        }),
      ); */
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schedulesMatrix - createSchedulesMatrix - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.createSchedulesMatrixFailure());
    yield put(DialogsActions.setClose());
  }
}

function* update({
  payload,
}: ReturnType<
  typeof SchedulesMatrixActions.updateSchedulesMatrixRequest
>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Editando dados' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.update, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      if (response.data) {
        yield put(
          SchedulesMatrixActions.updateSchedulesMatrixSuccess({
            schedulesMatrixData: response.data,
          }),
        );
        yield put(DialogsActions.setClose());
      }

      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Matriz alterada com sucesso',
        }),
      );

      yield put(SchedulesMatrixActions.listSchedulesMatrixRequest({}));
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schedulesMatrix - updateSchedulesMatrix - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.updateSchedulesMatrixFailure());
    yield put(DialogsActions.setClose());
  }
}

function* remove({
  payload,
}: ReturnType<
  typeof SchedulesMatrixActions.deleteSchedulesMatrixRequest
>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Excluindo matriz' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.delete, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Matriz excluída com sucesso',
        }),
      );

      yield put(DialogsActions.setClose());
      yield put(SchedulesMatrixActions.listSchedulesMatrixRequest({}));
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schedulesMatrix - removeSchedulesMatrix - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.deleteSchedulesMatrixFailure());
    yield put(DialogsActions.setClose());
  }
}

function* listConfig({
  payload,
}: ReturnType<
  typeof SchedulesMatrixActions.listSchedulesMatrixConfigRequest
>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({ title: 'Carregando configurações' }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.getConfig, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        SchedulesMatrixActions.listSchedulesMatrixConfigSuccess({
          schedulesMatrixConfigList: response.data,
          totalCount: parseInt(response.headers.totalcount, 10),
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schedulesMatrix - listSchedulesMatrixConfig - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.listSchedulesMatrixConfigFailure());
    yield put(DialogsActions.setClose());
  }
}

function* getConfig({
  payload,
}: ReturnType<
  typeof SchedulesMatrixActions.getSchedulesMatrixConfigRequest
>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando dados' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.getConfig, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        SchedulesMatrixActions.getSchedulesMatrixConfigSuccess({
          schedulesMatrixConfigData: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schedulesMatrix - getSchedulesMatrixConfig - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.getSchedulesMatrixConfigFailure());
    yield put(DialogsActions.setClose());
  }
}

function* createConfig({
  payload,
}: ReturnType<
  typeof SchedulesMatrixActions.createSchedulesMatrixConfigRequest
>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({ title: 'Criando configurações' }),
    );

    const response = yield call(schedulesMatrixApi.createConfig, {
      data: payload,
    });

    if (response.status === 200) {
      yield put(
        SchedulesMatrixActions.createSchedulesMatrixConfigSuccess({
          schedulesMatrixConfigData: response.data,
        }),
      );
      yield put(DialogsActions.setClose());

      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Configurações criadas com sucesso',
        }),
      );

      window.location.replace(PATH.SCHEDULES_MATRIX.BASE_URL);
      yield put(SchedulesMatrixActions.listSchedulesMatrixRequest({}));
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error(
      'schedulesMatrix - createSchedulesMatrixConfig - error',
      error,
    );

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.createSchedulesMatrixConfigFailure());
    yield put(DialogsActions.setClose());
  }
}

function* updateConfig({
  payload,
}: ReturnType<
  typeof SchedulesMatrixActions.updateSchedulesMatrixConfigRequest
>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Editando dados' }));

    const response = yield call(schedulesMatrixApi.updateConfig, {
      data: payload,
    });

    if (response.status === 200) {
      if (response.data) {
        yield put(
          SchedulesMatrixActions.updateSchedulesMatrixConfigSuccess({
            schedulesMatrixConfigData: response.data,
          }),
        );
        yield put(DialogsActions.setClose());
      }

      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Configurações alteradas com sucesso',
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schedulesMatrix - updateSchedulesMatrix - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.updateSchedulesMatrixConfigFailure());
    yield put(DialogsActions.setClose());
  }
}

function* removeConfig({
  payload,
}: ReturnType<
  typeof SchedulesMatrixActions.deleteSchedulesMatrixConfigRequest
>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({ title: 'Excluindo configurações' }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.delete, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Configurações excluídas com sucesso',
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schedulesMatrix - removeSchedulesMatrix - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.deleteSchedulesMatrixConfigFailure());
    yield put(DialogsActions.setClose());
  }
}

function* listTripSchedules({
  payload,
}: ReturnType<typeof SchedulesMatrixActions.listTripSchedulesRequest>): any {
  try {
    const { body, doNotShowloading } = payload;
    if (!doNotShowloading) {
      yield put(DialogsActions.setOpenLoading({ title: 'Carregando dados' }));
    }

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.getTripSchedules, {
      params: { transportOperatorId: transportOperator.id, ...body },
    });

    if (response.status === 200) {
      yield put(
        SchedulesMatrixActions.listTripSchedulesSuccess({
          tripSchedulesList: response.data,
          totalCount: parseInt(response.headers.totalcount, 10),
        }),
      );

      if (!doNotShowloading) yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('tripSchedule - tripScheduleList - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.listTripSchedulesFailure());
    yield put(DialogsActions.setClose());
  }
}

function* createTripSchedules({
  payload,
}: ReturnType<typeof SchedulesMatrixActions.createTripSchedulesRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Criando Escala' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.createTripSchedules, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        SchedulesMatrixActions.createTripSchedulesRequest({
          tripSchedulesData: response.data,
        }),
      );
      yield put(DialogsActions.setClose());

      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Escala criada com sucesso',
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('tripSchedule - createTripSchedule - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.createTripSchedulesFailure());
    yield put(DialogsActions.setClose());
  }
}

function* updateTripSchedules({
  payload,
}: ReturnType<typeof SchedulesMatrixActions.updateTripSchedulesRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Editando dados' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.updateTripSchedules, {
      data: payload,
    });

    if (response.status === 200) {
      if (response.data) {
        yield put(
          SchedulesMatrixActions.updateTripSchedulesSuccess({
            tripSchedulesData: response.data,
          }),
        );
        yield put(DialogsActions.setClose());
      }

      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Escala alterada com sucesso',
        }),
      );

      window.location.replace(PATH.SCHEDULES.BASE_URL);
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('tripSchedule - updateSchedulesMatrix - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.updateTripSchedulesFailure());
    yield put(DialogsActions.setClose());
  }
}

function* getTripSchedules({
  payload,
}: ReturnType<typeof SchedulesMatrixActions.getTripSchedulesRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando dados' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.getTripSchedules, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        SchedulesMatrixActions.getTripSchedulesSuccess({
          tripSchedulesData: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('tripSchedule - tripScheduleList - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.getTripSchedulesFailure());
    yield put(DialogsActions.setClose());
  }
}

function* tripScheduleInfo({
  payload,
}: ReturnType<typeof SchedulesMatrixActions.tripScheduleInfoRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Salvando...' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.tripScheduleInfo, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      if (response.data) {
        yield put(SchedulesMatrixActions.tripScheduleInfoSuccess({}));
        yield put(DialogsActions.setClose());
      }

      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Informações salvas com sucesso',
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('tripSchedule - updateSchedulesMatrix - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.tripScheduleInfoFailure());
    yield put(DialogsActions.setClose());
  }
}

function* tripScheduleProfileResevations({
  payload,
}: ReturnType<
  typeof SchedulesMatrixActions.tripScheduleProfileResevationsRequest
>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Salvando...' }));
    const { body, editMatrixId, selectedDate } = payload;
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.tripScheduleeReservations, {
      data: { transportOperatorId: transportOperator.id, ...body },
    });

    if (response.status === 200) {
      if (response.data) {
        yield put(
          SchedulesMatrixActions.tripScheduleProfileResevationsSuccess({}),
        );
        yield put(
          SchedulesMatrixActions.listTripSchedulesRequest({
            body: {
              scheduleMatrixId: editMatrixId,
              date: selectedDate
                ? new Date(selectedDate).getTime()
                : new Date().getTime(),
              _includes: 'schedulematrixconfig,reservation',
            },
          }),
        );
        yield put(DialogsActions.setClose());
        yield put(DialogsActions.setSecondClose());
      }

      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Informações salvas com sucesso',
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('tripSchedule - Profile Resevations - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.tripScheduleProfileResevationsFailure());
    yield put(DialogsActions.setClose());
  }
}

function* removeTripSchedules({
  payload,
}: ReturnType<typeof SchedulesMatrixActions.deleteTripSchedulesRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Excluindo dado...' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(schedulesMatrixApi.deleteListTripSchedules, {
      data: payload,
    });

    if (response.status === 200) {
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Escala excluída com sucesso',
        }),
      );

      yield put(SchedulesMatrixActions.deleteTripSchedulesSuccess());
      yield put(DialogsActions.setClose());
      window.location.replace(PATH.SCHEDULES.BASE_URL);
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('tripSchedule - removeSchedulesMatrix - error', error);

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(SchedulesMatrixActions.deleteTripSchedulesFailure());
    yield put(DialogsActions.setClose());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const schedulesMatrixSagas = [
  takeLatest(SchedulesMatrixTypes.LIST_SCHEDULES_MATRIX_REQUEST, list),
  takeLatest(SchedulesMatrixTypes.GET_SCHEDULES_MATRIX_REQUEST, get),
  takeLatest(SchedulesMatrixTypes.CREATE_SCHEDULES_MATRIX_REQUEST, create),
  takeLatest(SchedulesMatrixTypes.UPDATE_SCHEDULES_MATRIX_REQUEST, update),
  takeLatest(SchedulesMatrixTypes.DELETE_SCHEDULES_MATRIX_REQUEST, remove),
  takeLatest(
    SchedulesMatrixTypes.LIST_SCHEDULES_MATRIX_CONFIG_REQUEST,
    listConfig,
  ),
  takeLatest(
    SchedulesMatrixTypes.GET_SCHEDULES_MATRIX_CONFIG_REQUEST,
    getConfig,
  ),
  takeLatest(
    SchedulesMatrixTypes.CREATE_SCHEDULES_MATRIX_CONFIG_REQUEST,
    createConfig,
  ),
  takeLatest(
    SchedulesMatrixTypes.UPDATE_SCHEDULES_MATRIX_CONFIG_REQUEST,
    updateConfig,
  ),
  takeLatest(
    SchedulesMatrixTypes.DELETE_SCHEDULES_MATRIX_CONFIG_REQUEST,
    removeConfig,
  ),
  takeLatest(
    SchedulesMatrixTypes.LIST_TRIP_SCHEDULES_REQUEST,
    listTripSchedules,
  ),
  takeLatest(
    SchedulesMatrixTypes.CREATE_TRIP_SCHEDULES_REQUEST,
    createTripSchedules,
  ),
  takeLatest(
    SchedulesMatrixTypes.UPDATE_TRIP_SCHEDULES_REQUEST,
    updateTripSchedules,
  ),
  takeLatest(
    SchedulesMatrixTypes.DELETE_TRIP_SCHEDULES_REQUEST,
    removeTripSchedules,
  ),
  takeLatest(SchedulesMatrixTypes.GET_TRIP_SCHEDULES_REQUEST, getTripSchedules),
  takeLatest(
    SchedulesMatrixTypes.TRIP_SCHEDULES_INFO_REQUEST,
    tripScheduleInfo,
  ),
  takeLatest(
    SchedulesMatrixTypes.TRIP_SCHEDULES_PROFILE_RESEVATIONS_REQUEST,
    tripScheduleProfileResevations,
  ),
];
